import * as React from "react";
const paymentsUIContextValues = {
  isProcessingOrder: false,
  setIsProcessingOrder: () => null,
  paymentQRCodeState: void 0,
  setPaymentQRCodeState: () => null,
  isQrCodeModalOpen: false,
  setIsQrCodeModalOpen: () => null,
  currentCardBrand: void 0,
  setCurrentCardBrand: () => null,
  googlePayToken: void 0,
  setGooglePayToken: () => null,
  selectedPaymentMethodPrice: void 0,
  setSelectedPaymentMethodPrice: () => null,
  cartPrices: void 0,
  lineItems: []
};
const PaymentsUIContext = React.createContext(paymentsUIContextValues);
const usePaymentsUIContext = () => {
  const context = React.useContext(PaymentsUIContext);
  if (context === paymentsUIContextValues) {
    throw new Error(
      "No PaymentUI Context available. You might still need to wrap the application with the paymentUIContextProvider component."
    );
  }
  return context;
};
PaymentsUIContext.displayName = "PaymentsUIContext";
PaymentsUIContext.Consumer;
export {
  PaymentsUIContext,
  usePaymentsUIContext
};
//# sourceMappingURL=context.js.map
